import { SkeletonBlock } from './SkeletonBlock';

export function PageSkeleton() {
  return (
    <div className="animate-pulse space-y-6 py-6 px-4 max-w-5xl mx-auto" aria-hidden="true">
      <SkeletonBlock height="h-64" />
      <SkeletonBlock height="h-8" className="w-1/3" />
      <SkeletonBlock height="h-4" className="w-full" />
      <SkeletonBlock height="h-4" className="w-5/6" />
      <SkeletonBlock height="h-4" className="w-4/6" />
      <div className="grid grid-cols-3 gap-4 pt-4">
        <SkeletonBlock height="h-40" />
        <SkeletonBlock height="h-40" />
        <SkeletonBlock height="h-40" />
      </div>
    </div>
  );
}
